import React from 'react';

import { FIRE_CLASS_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';
import { FireIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type FireOverview = NonNullable<AnalyticDetailsEvent['event']['overview']> & {
  fire?: {
    fireClass?: unknown;
    fireScore?: number;
  };
};

export function FireDetails({ event }: { event: AnalyticDetailsEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const overview: FireOverview | undefined = event.event.overview;
  const fire = overview?.fire;
  const score = calculateProbabilityPercent(fire?.fireScore);
  const fireClass = fire?.fireClass;
  let fireClassLabel: string | undefined;
  if (typeof fireClass === 'number') fireClassLabel = FIRE_CLASS_OPTIONS[fireClass]?.label;

  return (
    <BaseVideoAnalyticsDetails
      event={event}
      tags={(
        <React.Fragment>
          {!!fireClassLabel && (
            <Tag
              data-testid="workspace.analyticEventDetails.tagType"
              kind="neutral"
              size="large"
              value={fireClassLabel}
            />
          )}

          <Tag
            data-testid="workspace.analyticEventDetails.extraTagType"
            icon={<FireIcon />}
            kind="neutral"
            size="large"
            value={`${t('videoAnalytics:fireAnalyticDetails.workspace.tag.label')} ${score}%`}
          />
        </React.Fragment>
      )}
      title={t('videoAnalytics:fireAnalyticDetails.workspace.title')}
    />
  );
}
